@import '../../../globals/main.scss';
@import './pn-marketweb-siteheader-common.scss';

.siteheader-search {
  a {
    display: none;
    @media screen and (min-width: $siteheader-media-tablet) {
      display: block;
    }
  }
  pn-search-field > .input-container button {
    background: $white;
  }
  pn-search-field.button-icon pn-button,
  pn-button {
    display: inline-flex;
    button {
      align-self: center;
      padding: 0;
      height: 2.3em;
      width: 2.4em;
      line-height: 0;
      min-height: unset;
      min-width: initial;
    }
    pn-icon {
      margin-left: 0;
    }
    .pn-button-tooltip {
      line-height: initial !important;
    }
  }
  form {
    justify-content: flex-end;
    align-items: stretch;
    width: auto;
    flex: none;
    display: flex;
    padding: 0;
    margin: 0 0 0 0.4rem;
    position: relative;
    flex-direction: column;
    @media screen and (min-width: $siteheader-media-tablet) {
    }
    @media screen and (min-width: $siteheader-media-smalldesktop) {
      margin-right: 1.6rem;
    }
    pn-search-field {
      min-width: 13.5em;
      .input-container {
        align-self: center;
      }
      input {
        height: auto;
        min-height: 1em;
        padding: 0.6em 0.75em;
      }
    }
  }
}
